import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./components/context/AuthContext";
import "./css/App.css";
import SnackbarProvider from "./components/constant_components/providers/SnackbarProvider.jsx";
import "./css/tailwind.css";
import { AppRoutes } from "@routes/AppRoutes";
import "./i18n"; // Import your i18n configuration

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <SnackbarProvider>
        <AuthProvider>
          <BrowserRouter basename="/react">
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </SnackbarProvider>
    </QueryClientProvider>
  );
};

export default App;
